import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MessageModal = ({ match, onClose, onSend }) => {
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  const handleSend = async () => {
    if (!message?.trim()) return;
    
    setIsSending(true);
    await onSend(match?.id, message);
    setMessage('');
    setIsSending(false);
  };

  const mockConversation = [
    {
      id: 1,
      sender: 'employer',
      content: "Thank you for your interest in this opportunity. I\'d love to learn more about your experience in leading technical teams.",
      timestamp: new Date(Date.now() - 172800000)
    },
    {
      id: 2,
      sender: 'candidate',
      content: "I appreciate your interest. I have extensive experience managing cross-functional engineering teams and driving product development initiatives. What specific aspects would you like to discuss?",
      timestamp: new Date(Date.now() - 86400000)
    },
    {
      id: 3,
      sender: 'employer',
      content: "I\'m particularly interested in your approach to scaling engineering organizations and your experience with distributed teams. Could you share some insights?",
      timestamp: new Date(Date.now() - 43200000)
    }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-[#E5E7EB]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center">
              <Icon name="User" size={24} color="#FFFFFF" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-semibold text-[#111827]">{match?.title}</h3>
              <p className="text-xs md:text-sm text-[#6B7280]">{match?.stage}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-[#F6F7FB] rounded-lg transition-colors"
            aria-label="Close message modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4">
          {mockConversation?.map((msg) => (
            <div
              key={msg?.id}
              className={`flex ${msg?.sender === 'candidate' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-[80%] rounded-2xl p-3 md:p-4 ${
                  msg?.sender === 'candidate' ?'bg-[#5B2DFF] text-white' :'bg-[#F6F7FB] text-[#111827]'
                }`}
              >
                <p className="text-sm md:text-base mb-2">{msg?.content}</p>
                <p className={`text-xs ${msg?.sender === 'candidate' ? 'text-white/70' : 'text-[#6B7280]'}`}>
                  {new Date(msg.timestamp)?.toLocaleString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                  })}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="p-4 md:p-6 border-t border-[#E5E7EB]">
          <div className="flex gap-2 md:gap-3">
            <Input
              type="text"
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e?.target?.value)}
              onKeyPress={(e) => e?.key === 'Enter' && handleSend()}
              className="flex-1"
            />
            <Button
              variant="default"
              size="default"
              iconName="Send"
              loading={isSending}
              onClick={handleSend}
              disabled={!message?.trim()}
            >
              Send
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;